import { FC } from 'react';
import styled from 'styled-components';

import Checkbox from '~src/shared/form/Checkbox';

import { PeopleSectionHeader, SectionPart } from './styles/SectionStyles';

const SecondCol = styled(SectionPart)`
  padding-left: 10px;
`;

interface Props {
  id1: string;
  id2?: string;
  selectedValueOne: boolean;
  selectedValueTwo?: boolean;
  titleOne: string;
  help1?: string;
  titleTwo?: string;
  help2?: string;
  description2?: string;
  onChangeCheckboxOne: (isChecked: boolean) => void;
  onChangeCheckboxTwo?: ((isChecked: boolean) => void) | null;
}

// DoubleCheckBoxSection is a double checkbox component that can also display a single checkbox
const DoubleCheckBoxSection: FC<Props> = ({
  help1,
  help2,
  id1,
  id2,
  onChangeCheckboxOne,
  onChangeCheckboxTwo,
  selectedValueOne,
  selectedValueTwo = false,
  titleOne,
  titleTwo
}: Props) => (
  <PeopleSectionHeader>
    <SectionPart>
      <Checkbox
        id={id1}
        label={titleOne}
        onChange={onChangeCheckboxOne}
        isChecked={selectedValueOne}
        help={help1}
      />
    </SectionPart>
    {id2 && onChangeCheckboxTwo && (
      <SecondCol>
        <Checkbox
          id={id2}
          label={titleTwo}
          onChange={onChangeCheckboxTwo}
          isChecked={selectedValueTwo}
          help={help2}
        />
      </SecondCol>
    )}
  </PeopleSectionHeader>
);

export default DoubleCheckBoxSection;
